<!--------1st Card: Main/default card -------->
<div id="unusual-quantity-product" *ngIf="exceptionResolution?.expanded">
  <div class="alert-message">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <div data-cy="exception-unusual-quantity-text">
      {{
        exceptionResolution?.orderException?.errorMessage
          | replaceString
            : '%2'
            : exceptionResolution?.orderItem?.unitsOrdered.currentValue
      }}
    </div>
  </div>
  <div class="product-row">
    <div class="original-product-row">
      <div class="exception-img">
        <img
          src="{{ thumbnailImageURL }}"
          (error)="
            this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
          "
          *ngIf="!!thumbnailImageURL && !isOffline"
          class="product-image"
          [attr.data-cy]="
            'unsual-quantity-product-' +
            product?.productNumber +
            '-thumbnail-image'
          "
        />
        <ion-icon
          name="restaurant"
          *ngIf="!thumbnailImageURL || isOffline"
          class="product-image no-image"
          data-cy="exception-unusual-quantity-no-image-icon"
        ></ion-icon>
      </div>
      <div class="product-information">
        <div
          class="brand"
          data-cy="exception-unusual-quantity-product-brand-text"
        >
          {{ product?.summary?.brand }}
        </div>
        <div
          class="description"
          [attr.data-cy]="
            'unsual-quantity-product-' +
            product?.productNumber +
            '-description-text'
          "
        >
          {{ product?.summary?.productDescTxtl | acronymTitleCase }}
        </div>
      </div>
    </div>

    <div
      class="additional-product-info"
      [attr.data-cy]="
        'unsual-quantity-product-' + product?.productNumber + '-info-text'
      "
    >
      #{{ product?.productNumber }} <span class="border">|</span>
      {{ product?.summary?.salesPackSize }}
    </div>

    <div>
      <div
        class="ordered"
        [attr.data-cy]="
          'unsual-quantity-product-' + product?.productNumber + '-ordered-text'
        "
      >
        {{ 'i18n.common.ordered' | translate }}:
        <span
          >{{ exceptionResolution?.orderItem?.unitsOrdered.currentValue || 0 }}
          CS /
          {{ exceptionResolution?.orderItem?.eachesOrdered.currentValue || 0 }}
          EA</span
        >
      </div>
      <div
        class="reserved"
        [attr.data-cy]="
          'unsual-quantity-product-' + product?.productNumber + '-reserved-text'
        "
      >
        {{ 'i18n.common.reserved' | translate }}:
        <span>
          {{ exceptionResolution?.orderItem?.unitsReserved || 0 }} CS /
          {{ exceptionResolution?.orderItem?.eachesReserved || 0 }} EA
        </span>
      </div>
    </div>
  </div>
  <div class="quantity-input-group">
    <div class="quantity-input">
      <div class="input-wrapper">
        <app-quantity-input
          #unUsualQtyCasesInput
          [productNumber]="product?.productNumber"
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
          [quantity]="
            !!exceptionResolution?.resolutionOrderItem?.originalProduct
              ? exceptionResolution.resolutionOrderItem.originalProduct
                  .unitsOrdered
              : exceptionResolution?.orderException?.errorCode === 608 ||
                exceptionResolution?.orderException?.errorCode === 614 ||
                exceptionResolution?.orderException?.errorCode === 620 ||
                exceptionResolution?.orderException?.errorCode === 624
              ? suggestedUnits
              : exceptionResolution?.orderItem?.unitsOrdered
          "
          [isDisabled]="false"
          [isOffline]="isOffline"
          [platform]="platformEnum"
          [isEaches]="false"
        >
        </app-quantity-input>
      </div>
      <div
        class="quantity-text"
        [attr.data-cy]="
          'unsual-quantity-product-' +
          product?.productNumber +
          '-unit-price-text'
        "
      >
        {{
          (exceptionResolution?.orderItem?.unitPrice | currency) || 'loading..'
        }}
        {{ exceptionResolution?.orderItem?.priceUOM || 'CS' }}
      </div>
    </div>
    <ng-container *ngIf="isInputHidden">
      <div class="quantity-input">
        <div class="input-wrapper">
          <app-quantity-input
            #unUsualQtyEachesInput
            [productNumber]="product?.productNumber"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
            [quantity]="
              !!exceptionResolution?.resolutionOrderItem?.originalProduct
                ? exceptionResolution.resolutionOrderItem.originalProduct
                    .eachesOrdered
                : exceptionResolution?.orderException?.errorCode === 608 ||
                  exceptionResolution?.orderException?.errorCode === 614 ||
                  exceptionResolution?.orderException?.errorCode === 620 ||
                  exceptionResolution?.orderException?.errorCode === 624
                ? suggestedEaches
                : exceptionResolution?.orderItem?.eachesOrdered
            "
            [isDisabled]="false"
            [isOffline]="isOffline"
            [platform]="platformEnum"
            [isEaches]="true"
          >
          </app-quantity-input>
        </div>
        <div
          class="quantity-text"
          [attr.data-cy]="
            'unsual-quantity-product-' +
            product?.productNumber +
            '-each-price-text'
          "
        >
          {{
            (exceptionResolution?.orderItem?.eachPrice | currency) ||
              'loading..'
          }}
          {{ exceptionResolution?.orderItem?.priceUOM === 'LB' ? 'LB' : 'EA' }}
        </div>
      </div>
    </ng-container>
  </div>
  <div class="button-group">
    <ion-button
      class="usf-fill-green-button"
      data-cy="confirm-unusual-quanity-button"
      (click)="confirmQty()"
    >
      {{ 'i18n.common.confirmQuantities' | translate }}
    </ion-button>
  </div>
</div>

<!------- Message close button --------->
<div
  class="edit-section-header"
  *ngIf="!exceptionResolution?.expanded && !isClosed"
>
  <div>
    {{ 'i18n.common.edit' | translate }}:
    <span data-cy="unusual-quantity-confirmed-amount-text">
      {{
        'i18n.orderExceptionsPage.confirmedProductQuantities' | translate
      }}</span
    >
  </div>
  <ion-button
    class="usf-fill-green-button"
    data-cy="close-unusual-quanity-button"
    (click)="isMsgClosed()"
    >{{ 'i18n.common.close' | translate }}</ion-button
  >
</div>

<!------- Edit button to expand --------->
<div id="banner" *ngIf="!exceptionResolution?.expanded">
  <div class="exceptions-completed-product-info">
    <div class="exception-img">
      <img
        src="{{ thumbnailImageURL }}"
        (error)="
          this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
        "
        *ngIf="!!thumbnailImageURL && !isOffline"
        [attr.data-cy]="
          'unsual-quantity-product-' + product?.productNumber + '-banner-image'
        "
        class="product-image"
      />
      <ion-icon
        name="restaurant"
        *ngIf="!thumbnailImageURL || isOffline"
        data-cy="unusual-quanity-banner-no-image-icon"
        class="product-image no-image"
      ></ion-icon>
    </div>
    <div class="exceptions-completed-product-info-inner">
      <div
        class="brand-and-product-number"
        [attr.data-cy]="
          'unsual-quantity-product-' +
          product?.productNumber +
          '-banner-info-text'
        "
      >
        #{{ product?.productNumber }}
      </div>
      <div
        class="product-description"
        [attr.data-cy]="
          'unsual-quantity-product-' +
          product?.productNumber +
          '-banner-description-text'
        "
      >
        {{ product?.summary?.productDescTxtl | acronymTitleCase }}
      </div>
      <div
        class="product-status"
        [attr.data-cy]="
          'unsual-quantity-product-' +
          product?.productNumber +
          '-banner-status-text'
        "
      >
        {{ 'i18n.common.confirmed' | translate }}
      </div>
    </div>
  </div>
  <div
    class="edit-link"
    data-cy="edit-banner-unusual-quantity-button"
    (click)="edit()"
  >
    {{ 'i18n.common.edit' | translate }}
  </div>
</div>
